var React = require('react');

function BarendInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"barEndLinkGroup","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"barEndLink","transform":"translate(-1167.000000, -747.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("path",{"d":"M1220.42391,747 C1225.67062,747 1229.92391,751.253295 1229.92391,756.5 C1229.92391,761.746705 1225.67062,766 1220.42391,766 C1215.68796,766 1211.76142,762.534494 1211.04183,758.001011 L1167.07609,758 L1167.07609,755 L1211.04167,754.999988 C1211.76085,750.466015 1215.68761,747 1220.42391,747 Z","id":"Line"}))));
}

BarendInline.defaultProps = {"width":"63px","height":"19px","viewBox":"0 0 63 19","version":"1.1"};

module.exports = BarendInline;

BarendInline.default = BarendInline;
